import { declareTheme } from "@component-library/themes"

export const useTheme = declareTheme({
  default: {
    focus: true as boolean,
    outline: true as boolean
  }
})